import { fetcher } from '../utils'
import { ComponentMessageMediaVO } from '@repo/types'
import { GenericAbortSignal } from 'axios'

export default async (
  input: FormData,
  connectionKey: string,
  signal?: GenericAbortSignal
): Promise<ComponentMessageMediaVO> =>
  fetcher(`/api/chats/${connectionKey}/upload/media`, 'POST', undefined, input, signal)
